import React from 'react';
import Select from '../Select/Select';
import { useRegion } from 'modules/soato/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onChange?: () => void;
}

const Region: React.FC<Props> = ({ name, label, onChange, required, placeholder, disabled, ...props }) => {
  const { i18n } = useTranslation();
  const { data, isLoading } = useRegion();

  console.log('data', data);

  return (
    <Select
      name={name}
      label={label}
      optionValue="id"
      optionLabel={option => option.name[i18n.language]}
      options={data}
      required={required}
      placeholder={placeholder}
      disabled={disabled || !data?.length}
      onChange={onChange}
      isLoading={isLoading}
      {...props}
    />
  );
};

export default Region;
